import type { Schemas } from '#shopware'

export interface MegaMenuState {
  openedCategory: Ref<string | null>
  activeItem: ComputedRef<Schemas['Category'] | undefined>
  navigationItems: Ref<Schemas['NavigationRouteResponse'] | null>
}

export const useMegaMenu = () => {
    const navigationItems = inject<Ref<Schemas['NavigationRouteResponse'] | null>>('mainNavigation', ref(null))
    const openedCategory = useState<string | null>('megaMenuOpenedCategory', () => null)

    const activeItem = computed(() =>
        navigationItems.value?.find((item: Schemas['Category']) => item.id === openedCategory.value)
    )

    let popoverTimeout: ReturnType<typeof setTimeout> | null = null

    function openPopover(
        id: string,
        { delay = 200 }: { delay?: number } = {}
    ) {
        clearPopoverTimeout()

        popoverTimeout = setTimeout(() => {
            openedCategory.value = id
        }, delay)
    }

    function closePopover({ delay = 0 }: { delay?: number } = {}) {
        clearPopoverTimeout()

        if (delay > 0) {
            popoverTimeout = setTimeout(() => {
                openedCategory.value = null
            }, delay)
        } else {
            openedCategory.value = null
        }
    }

    function clearPopoverTimeout() {
        if (popoverTimeout) {
            clearTimeout(popoverTimeout)
            popoverTimeout = null
        }
    }

    return {
        navigationItems,
        openedCategory,
        activeItem,
        openPopover,
        closePopover,
        clearPopoverTimeout,
    }
}
